
export default () => async params => {
    console.log("LOG", params)
}